export default "__VITE_ASSET__67071b16__"